// TODO: Component under development. Commented code will be removed or added as the Sports module refactoring progresses.
import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { IonicModule } from "@ionic/angular";

@Component({
  selector: "sports-grid-helper",
  templateUrl: "./sports-grid-helper.component.html",
  standalone: true,
  imports: [IonicModule, CommonModule],
  styleUrls: ["./sports-grid-helper.component.scss"],
})
export class SportsGridHelperComponent implements OnInit {
  @Input() betweenI: boolean;
  @Input() bottomSpaceI: boolean;
  @Input() bottomSeparatorI: boolean;
  @Input() topSpaceI: boolean;
  @Input() topSeparatorI: boolean;

  between = false;
  bottomSpace = false;
  bottomSeparator = false;
  topSpace = false;
  topSeparator = false;

  ngOnInit(): void {
    this.between = this.betweenI;
    if (!this.betweenI) {
      this.bottomSpace = this.bottomSpaceI;
      this.bottomSeparator = this.bottomSeparatorI;
      this.topSpace = this.topSpaceI;
      this.topSeparator = this.topSeparatorI;
    }
  }
}
